

import { useTenantBlocked } from "@/contexts/TenantBlockedContext";
import { useTranslations } from "next-intl";
import { PBanner } from "./PBanner";

/**
 * F17 host — reads the context and renders the banner only when the
 * tenant is blocked AND the user hasn't dismissed the current session.
 * Sits inside the dashboard layout so every authenticated page gets it.
 */
export const TenantBlockedBannerHost: React.FC = () => {
  const { blocked, dismissedThisSession, dismiss } = useTenantBlocked();
  const t = useTranslations("userSettings.tenantBlocked");

  if (!blocked || dismissedThisSession) return null;

  return (
    <PBanner
      testId="tenant-blocked-banner"
      tone="danger"
      shape="strip"
      // The one place that keeps the loud filled slab: this is a hard block on
      // the whole account, not an advisory about a future date.
      emphasis="solid"
      title={t("title")}
      description={t("description")}
      onDismiss={dismiss}
    />
  );
};
